// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__bj0Q9","tabItem":"navigation_tabItem__J1Eof","tab":"navigation_tab__OwKW1","active":"navigation_active__d+ER9"};